<!-- Divider -->
<div
    class="cipafacil-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
